import { get, post } from '@/util/auth'

import {
  MANAGER_API_ACCEPT_EMPLOYEE_CONSENT,
  MANAGER_API_ACTIVE_EMPLOYEE_CONSENT,
  MANAGER_API_REVOKE_EMPLOYEE_CONSENT,
} from './apiRoutes'

export type ActiveConsentType = {
  id: number
  text: string
  datetime: string | null
  isConsentGiven: boolean
  isRevoked: boolean
  isRevokedDateTime: string | null
}

export const consentResources = {
  getActiveConsents: () => get<ActiveConsentType>(MANAGER_API_ACTIVE_EMPLOYEE_CONSENT, true),

  // Mutation
  acceptConsent: (consentId: number) =>
    post<boolean>(
      MANAGER_API_ACCEPT_EMPLOYEE_CONSENT.replace(':consentId', String(consentId)),
      {},
      true
    ),
  revokeConsent: (consentId: number) =>
    post<boolean>(
      MANAGER_API_REVOKE_EMPLOYEE_CONSENT.replace(':consentId', String(consentId)),
      {},
      true
    ),
}
